import {
  baseWhite,
  neutral300,
  neutral500,
  primary300,
  primary500,
  success500,
  warning500,
  error500,
} from '../../DesignToken/variables';
import vars from '../../vars';

function formItemStateBorder(color) {
  return `border-bottom: ${vars.form.item.borderWidth} solid ${color};`;
}

export const newFormItemPartials = {
  default: `
        background-color: ${baseWhite};
        position: relative;
        min-height: 48px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid ${neutral300};
        outline: none;
        line-height: 24px;
        &::placeholder {
          color: ${neutral500};
        }
    `,
  mini: `
    background-color: transparent;
    border: none;
    display: block;
    margin: 0;
    min-height: 0;
    padding: 0;
    width: auto;
  `,
  state: {
    default: `
        ${formItemStateBorder(neutral300)};
        transition: ${vars.transition.default};
        position: absolute;
        width: 100%;
        bottom: 0;
    `,
    hover: `
        ${formItemStateBorder(primary300)};
    `,
    active: `
        ${formItemStateBorder(primary500)};
    `,
    focus: `
        ${formItemStateBorder(primary500)};
    `,
    complete: `
        ${formItemStateBorder(success500)};
    `,
    warning: `
        ${formItemStateBorder(warning500)};
    `,
    error: `
    ${formItemStateBorder(error500)};
`,
  },
};
